export const useTenantName = () => {
    return useState('tenant-name', () => {
        return null
    });
}